"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
require("./badge.css");
var Badge = function (_a) {
    var size = _a.size, _b = _a.appearance, appearance = _b === void 0 ? 'normal' : _b, className = _a.className, children = _a.children, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? 'navy100' : _c, _d = _a.dataTest, dataTest = _d === void 0 ? 'badge' : _d, other = tslib_1.__rest(_a, ["size", "appearance", "className", "children", "backgroundColor", "dataTest"]);
    var classes = (0, classnames_1.default)('dsc-badge', size === 'small' || size === 'large' ? "is-".concat(size) : null, "bg-".concat(String(backgroundColor)), appearance !== 'normal' && "is-".concat(appearance), className);
    return ((0, jsx_runtime_1.jsx)("div", tslib_1.__assign({}, other, { className: classes, "data-test": dataTest, children: children })));
};
exports.Badge = Badge;
exports.Badge.displayName = 'Badge';
//# sourceMappingURL=badge.js.map